import { FlexBox } from '@vp/swan';
import { useStyles } from '@vp/ubik-context';
import styles, { stylesheet } from './SkeletonBox.module.scss';

const SkeletonBox = () => {
    useStyles(stylesheet);

    return <FlexBox className={styles.skeletonBox} justifyContent="center" loadingShimmer />;
};

export default SkeletonBox;
